/*
 * @format
 * @flow
 */

import {
    PLAYER_VOLUME,
    PLAYER_VIDEO_QUALITY,
    PLAYER_AUDIO,
} from '../actions/player';

const initialState = {
    volume: 0,
    videoQuality: null,
    audio: null,
};

export default function playerReducer(state = initialState, action) {
    switch (action.type) {
        case PLAYER_VOLUME: {
            return {...state, volume: action.volume};
        }
        case PLAYER_VIDEO_QUALITY: {
            return {...state, videoQuality: action.videoQuality};
        }

        case PLAYER_AUDIO: {
            return {...state, audio: action.audio};
        }

        default: {
            return state;
        }
    }
}
